import { render, staticRenderFns } from "./Duobaan.vue?vue&type=template&id=5480d9a7&scoped=true"
import script from "./Duobaan.vue?vue&type=script&lang=js"
export * from "./Duobaan.vue?vue&type=script&lang=js"
import style0 from "./Duobaan.vue?vue&type=style&index=0&id=5480d9a7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5480d9a7",
  null
  
)

export default component.exports